import { gql } from '@apollo/client';

import {
  EditQuestionMessageDocument,
  type EditQuestionMessageMutation,
  type EditQuestionMessageMutationVariables,
} from '../__generated__/documents';

/** Same response as `addQuestionMessage`, so `@unmask` on every spread for the same reason. */
if (false) {
  gql`
    mutation EditQuestionMessage($input: EditQuestionMessageInput!) {
      editQuestionMessage(input: $input) {
        isQuestionComplete
        isConversationOver
        surveyProgress
        sent {
          ...UnifiedMessage @unmask
        }
        replyFeedback {
          ...UnifiedMessage @unmask
        }
        reply {
          ...UnifiedMessage @unmask
        }
        nextQuestion {
          ...UnifiedQuestion @unmask
        }
        thankYouMessage {
          ...UnifiedMessage @unmask
        }
        actions {
          preActivationActionType
          preActivationActionData
          postActivationActionType
          postActivationActionData
        }
      }
    }
  `;
}

export const EDIT_QUESTION_MESSAGE = EditQuestionMessageDocument;
export type {
  EditQuestionMessageMutation,
  EditQuestionMessageMutationVariables,
};
